import type { TFieldKey } from "@./suf-store";
import { useSignupFlowStore } from "../hooks/useSignUpFlowStore";
import { useSignupFlowErrorStore } from "../hooks/useSignUpFlowErrorStore";
import { SignupFlowSlug, SIGNUP_FLOW_PAGES } from "../constants";
import { createFlowValidation } from "../../../shared/createFlowValidation";
import type { RequiredFieldData } from "../../../shared/baseStore.types";
import { inABTestGroupFromSingleton } from "../featureFlags";

import { signupFieldValidations } from "./signupFieldValidations";
import { requiredFieldsBySlug } from "./requiredFieldsBySlug";

const { validateField, getRequiredFieldsForSlug: getRequiredFieldsForSlugWithContext } =
  createFlowValidation<TFieldKey, SignupFlowSlug>({
    getState: useSignupFlowStore.getState,
    errorStore: useSignupFlowErrorStore.getState(),
    fieldRules: signupFieldValidations,
    requiredFieldsBySlug,
    isUserPage: (slug) => SIGNUP_FLOW_PAGES[slug]?.isUserPage ?? false,
  });

const SINGLETON_FLAG_CONTEXT: Pick<RequiredFieldData, "inABTestGroup"> = {
  inABTestGroup: inABTestGroupFromSingleton,
};

const getRequiredFieldsForSlug = (
  slug: SignupFlowSlug,
  context = SINGLETON_FLAG_CONTEXT,
): TFieldKey[] => getRequiredFieldsForSlugWithContext(slug, context);

export { validateField as validateSignUpField, getRequiredFieldsForSlug };
